import type { TList } from '@/services/api';
import type { TNetworkError } from '@/services/errors';
import type { TApplicantPriorityDTO, TApplicantScoreDTO } from './scoring.dto';

import { BaseService } from '@/services/api';

import type {
  TApplicantPriority,
  TApplicantScore,
  TSaveScorePayload,
} from './scoring.types';

import { PRIORITY_FIELDS, SCORE_FIELDS } from './scoring.fields';
import { toApplicantPriority, toApplicantScore } from './scoring.adapters';

class ScoringService extends BaseService {
  protected readonly serviceName = 'scoringService';

  public listScores(applicantID: string): Promise<TList<TApplicantScore> | TNetworkError> {
    return this.runList(
      this.db
        .from('user_scoring')
        .select(SCORE_FIELDS, { count: 'exact' })
        .eq('id', applicantID)
        .returns<TApplicantScoreDTO[]>(),
      'listScores',
      toApplicantScore,
    );
  }

  public readPriority(applicantID: string): Promise<TApplicantPriority | TNetworkError> {
    return this.run(
      this.db
        .from('user_priority')
        .select(PRIORITY_FIELDS)
        .eq('user_id', applicantID)
        .single()
        .returns<TApplicantPriorityDTO>(),
      'readPriority',
      toApplicantPriority,
    );
  }

  public saveScore({
    applicantID, qualityScore, archetype, staffID,
  }: TSaveScorePayload): Promise<TApplicantScore | TNetworkError> {
    return this.run(
      this.db
        .from('user_scoring')
        .upsert({
          id: applicantID,
          quality_score: qualityScore,
          archetype,
          updated_by: staffID,
        })
        .select(SCORE_FIELDS)
        .single()
        .returns<TApplicantScoreDTO>(),
      'saveScore',
      toApplicantScore,
    );
  }
}

const scoringService = new ScoringService();

export {
  scoringService,
};
